import { cn } from '@/lib/utils';

export const SectionHeader = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <h2 className={cn('text-xl', 'font-semibold', className)}>{children}</h2>;
};
